var definitionListItem = 'definitionListItem_definitionListItem__17s06wu0';

export { definitionListItem };
//# sourceMappingURL=definitionListItem.vanilla.mjs.map
